import React, { useEffect, useReducer, useState } from "react"
import { obterTelefonesBloqueados } from "../../../services/telefonesBloqueados"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { TelefoneBloqueadosInicial } from "../models/telefonesBloqueadosModel"
import { TelefoneBloqueadosContext } from "./TelefoneBloqueadosContext"
import { TelefoneBloqueadosActionsTypes } from "./telefonesBloqueadosActions"
import { telefonesBloqueadosReducer } from "./telefonesBloqueadosReducer"

export function TelefoneBloqueadosContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(telefonesBloqueadosReducer, TelefoneBloqueadosInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterTelefonesBloqueados(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar")
            } else {
                setErroCarregamento(null)
                dispatch({ type: TelefoneBloqueadosActionsTypes.CARREGAR, payload: response })
            }
        } catch {
            setErroCarregamento("Erro ao carregar")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
    }, [])

    return (
        <TelefoneBloqueadosContext.Provider value={{ dados, dispatch, erroCarregamento }}>
            <Loading />
            {children}
        </TelefoneBloqueadosContext.Provider>
    )
}
